/** @jsxImportSource theme-ui */
import { useField } from 'formik';
import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { SemanticFormikProps } from './FormikSemanticProps';

export const FormikSemanticCheckbox: React.FC<SemanticFormikProps> = ({
  name,
  placeholder,
  error,
  disabled = false,
}) => {
  const [field, ,] = useField(name);
  const { value, onChange, onBlur } = field;

  return (
    <Checkbox
      label={placeholder}
      // placeholder={placeholder}
      name={name}
      error={error}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      checked={value}
    />
  );
};
